import React, { useEffect, useState } from "react";
import "./ProfilePage.css";
import customerApi from "../../../services/apiServices/customerApi";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../services/redux/loadingSlice";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { maskCEP, maskDocument } from "../../../components/masks/masks";

const ProfilePage = () => {
    const [customer, setCustomer] = useState(null);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchCustomer = async () => {
            try {
                dispatch(setLoading(true));
                const response = await customerApi.getCustomerByUserCode(0, {include: "User.Address.City"}); // Fetching with ID = 0 as instructed
                setCustomer(response);
            } catch (err) {
                console.error("Error fetching customer profile:", err);
                setError("Erro ao carregar perfil. Tente novamente.");
            } finally {
                dispatch(setLoading(false));
            }
        };

        fetchCustomer();
    }, [dispatch]);

    if (error) {
        return <p className="profile-error-message">{error}</p>;
    }

    if (!customer) {
        return <p className="profile-loading-message">Carregando...</p>;
    }

    const { User } = customer;
    const address = User.Address[0];

    return (
        <div className="profile-page">
            <PageTitle title="Perfil do Cliente" />
            <div className="profile-container">
                <h3 className="profile-section-title">Informações Pessoais</h3>
                <div className="profile-info">
                    <p>
                        <strong>Nome:</strong> {User.Name}
                    </p>
                    <p>
                        <strong>E-mail:</strong> {User.Email}
                    </p>
                    <p>
                        <strong>CPF/CNPJ:</strong> {maskDocument(User.Document1)}
                    </p>
                </div>

                <h3 className="profile-section-title">Endereço</h3>
                <div className="profile-address">
                    <p>
                        <strong>Rua:</strong> {address.StStreet}, {address.NrBuildIngsite}
                    </p>
                    <p>
                        <strong>Bairro:</strong> {address.StNeighborhood}
                    </p>
                    <p>
                        <strong>Cidade:</strong> {address.City ? address.City.Name + ' / ' + address.City.State : "Não informado"}
                    </p>
                    <p>
                        <strong>CEP:</strong> {maskCEP(address.StZipCode)}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
